<template lang="pug">
  v-dialog(
    v-model="show"
    content-class="item-dialog"
    scrollable
    tile
  )
    v-progress-circular(
      v-if="loading"
      indeterminate
      color="primary"
      :size="100"
    )
    v-card(
      v-else
      class="item-card"
    )
      v-img(
        v-if="details.length"
        cover
        class="top-carousel"
        :src="details[0].item_imageurl"
      )
        .image-overlay
          v-btn(
            class="mx-2 close-button"
            fab
            dark
            small
            color="white"
            @click="deselect"
          ) 
            v-icon mdi-close
      v-container(v-if="details.length")
        em.header-title {{ details[0].item_description }}
        v-spacer
        h3.mt-5(v-if="variant_list.length") Variant
        v-list(
          v-if="variant_list.length"
          class="p-0"
          two-line
          flat
        )
          v-list-item-group(
            v-model="selection"
            active-class="primary--text"
          )
            template(v-for="(v, index) in variant_list")
              v-list-item(
                :class="v.item_inventory ? 'menu-item item' : 'menu-no-stock item'"
                :key="v.variant_id"
                @click="selectVariant(v)"
              )
                template(v-slot:default="{ active }")
                  v-list-item-icon(
                    class="item-image"
                  )
                    img(
                      :src="v.variant_imageurl"
                    )
                  v-list-item-content
                    v-list-item-title
                      b {{ v.variant_name }}
                    v-list-item-subtitle {{ v.variant_description }}
                  v-list-item-action
                    span(
                      :class="v.variant_saleprice > 0 ? 'stroke-price' : ''"
                    ) + RM {{ v.variant_price }}
                    span(
                      class="sale-price"
                      v-if="v.variant_saleprice > 0"
                    ) + RM {{ v.variant_saleprice }}
                  //- v-list-item-action(v-if="selectedVariant && selectedVariant.variant_id == v.variant_id")
                  //-   b X 1
              v-divider(
                class="m-0"
                v-if="index < variant_list.length - 1"
                :key="index"
              )
        //- v-card-subtitle(v-else)
        //-   b Not Applicable.
        v-spacer
        h3.mt-4(v-if="addon_list.length") Add-Ons
        v-list(
          v-if="addon_list.length"
          class="p-0"
          two-line
          flat
        )
          v-list-item-group(
            active-class="primary--text"
          )
            template(v-for="(a, index) in addon_list")
              v-list-item(
                class="item"
                :key="a.addon_id"
                @click="selectAddon(a)"
              )
                template(v-slot:default="{ active }")
                  v-list-item-icon(
                    class="item-image"
                  )
                    img(
                      :src="a.addon_imageurl"
                    )
                  v-list-item-content
                    v-list-item-title
                      b {{ a.addon_name }}
                    v-list-item-subtitle {{ a.addon_description }}
                  v-list-item-action
                    span(
                      :class="a.addon_saleprice > 0 ? 'stroke-price' : ''"
                    ) + RM {{ a.addon_price }}
                    span(
                      class="sale-price"
                      v-if="a.addon_saleprice > 0"
                    ) + RM {{ a.addon_saleprice }}
                  //- v-list-item-action(v-if="selectedAddon.findIndex(x=>x.addon_id==a.addon_id) > -1")
                  //-   b X 1
              v-divider(
                class="m-0"
                v-if="index < addon_list.length - 1"
                :key="index"
              )
        //- v-card-subtitle(v-else)
        //-   b Not Applicable.
        v-textarea(
          class="mt-4 m-2 pt-4"
          clearable
          clear-icon="mdi-close-circle"
          label="Remarks"
          v-model="remarks"
        )
      v-row(
        class="item-card-button w-100 m-0"
        align="center"
        justify="center"
      )
        .d-flex.flex-row.item-card-quantity
          v-btn(
            fab
            small
            text
            color="primary"
            @click="minus"
          )
            v-icon mdi-minus
          v-text-field(
            class="mb-4"
            v-model.number="quantity"
            :hint="`${itemStock} left.`"
            persistent-hint
            :min="1"
            :max="itemStock"
          )
          v-btn(
            fab
            small
            text
            color="primary"
            @click="add"
          )
            v-icon mdi-plus
        v-btn(
          class="m-0"
          tile
          color="primary"
          @click="addToCart"
        )
          //- v-icon(center) mdi-plus
          span Add to Cart
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    dialog: Boolean,
    merchantId: String,
    storeId: String,
    menuId: Number,
    itemId: String,
    merchantName: String,
    storeName: String,
    itemName: String,
    constraints: Object,
    itemStock: Number
  },
  data() {
    return {
      remarks: "",
      quantity: 1,
      selection: null,
      selectedVariant: null,
      selectedAddon: [],
      details: [],
      variant_list: [],
      addon_list: [],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("deselect");
      }
    }
  },
  mounted() {
    this.getItemDetails();
  },
  methods: {
    minus() {
      if (this.quantity > 1) this.quantity -= 1;
    },
    add() {
      if (this.quantity < this.itemStock) this.quantity += 1;
    },
    deselect() {
      this.$emit("deselect");
    },
    addToCart() {
      if (this.quantity == 0) return;
      if (this.variant_list.length && !this.selectedVariant) return;
      const payload = {
        merchant_id: this.merchantId,
        store_id: this.storeId,
        order_item: {
          menu_id: this.menuId,
          item_id: this.itemId,
          item_stock: this.selectedVariant
            ? this.selectedVariant.item_inventory
            : this.itemStock,
          item_name: this.itemName,
          item_price: this.details[0].item_price,
          item_quantity: this.quantity,
          item_saleprice: this.details[0].item_onsale
            ? (
                (this.details[0].item_price *
                  (100 - this.details[0].item_salepercent)) /
                100
              ).toFixed(2)
            : 0,
          item_variant: this.selectedVariant,
          item_addon: this.selectedAddon,
          item_remarks: this.remarks
        }
      };

      this.$store.commit("customer/addToDineIn", payload);

      this.storeConstraint();
      this.deselect();
    },
    storeConstraint() {
      const payload = {
        constraintId: this.constraints.id,
        dineInMinimum: this.constraints.dinein_minimum,
        dineInExtra: this.constraints.dinein_extra,
        reserveMinimum: this.constraints.reserve_minimum,
        reserveExtra: this.constraints.reserve_extra,
        pickupMinimum: this.constraints.pickup_minimum,
        pickupExtra: this.constraints.pickup_extra,
        deliveryMinimum: this.constraints.delivery_minimum,
        deliveryExtra: this.constraints.delivery_extra
      };

      this.$store.commit("customer/storeConstraint", payload);
    },
    selectVariant(v) {
      if (this.selectedVariant && this.selectedVariant.variant_id == v.variant_id) {
        this.selectedVariant = null;
      } else {
        let body = Object.assign({}, v);
        delete body["variant_imageurl"];
        this.selectedVariant = body;
      }
    },
    selectAddon(a) {
      var idx = this.selectedAddon.findIndex(x => x.addon_id == a.addon_id);
      if (idx > -1) this.selectedAddon.splice(idx, 1);
      else {
        let body = Object.assign({}, a);
        delete body["addon_imageurl"];
        this.selectedAddon.push(body);
      }
    },
    getItemDetails() {
      let url = config.itemDetailsUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          menu_id: this.menuId,
          item_id: this.itemId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.details = response.body.data;
                this.variant_list = response.body.variant;
                this.addon_list = response.body.addon;
              } else {
                this.$swal(
                  this.$t("error.get_merchant_details"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_details"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_details"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
